<template>
  <div class="container pb-16">
    <navigation-drawer :titles="title"/>
    <div class="row align-items-center">
      <div class="col-6">
        <div class="mr-2 mb-2 font16px mt-5">نقش را انتخاب کنید</div>
        <v-autocomplete
            class="input-border"
            v-model="typeRole"
            :items="$roles"
            item-text="name"
            item-value="id"
            placeholder="انتخاب نقش"
            dense
            hide-details
            solo
        ></v-autocomplete>
      </div>
      <div class="col-6 align-self-end">
        <v-btn dark color="primary" class="rounded-lg" large elevation="0"
               @click="searchUsers">
          <span class="font16px">جستجو</span>
        </v-btn>
      </div>
      <div v-if="isListLoaded && list.length === 0" class="col-6">
        <v-alert color="primary" class="rounded-lg white--text"> نتیجه ای یافت نشد</v-alert>
      </div>
      <div v-if="isListLoaded && list.length > 0" class="col-12">
        <v-data-table
            id="dataTable"
            :headers="headers"
            :items="list"
            :items-per-page="5"
            :light="true"
            :mobile-breakpoint="680"
            :search="search"
            :single-expand="singleExpand"
            class="data-table"
            fixed-header
            item-key="Id"
        >
          <template v-slot:[`item.FileUrl`]="{ item }">
            <div class="p-2 d-flex justify-content-center">
              <v-img v-if="item.FileUrl != null" :src="$replaceHttps(item.FileUrl)" height="80"
                     width="80" contain>
              </v-img>
              <v-img v-else :src="getImgUrl(src)" height="80"
                     width="80" contain></v-img>
            </div>
          </template>
          <template v-slot:[`item.IsActive`]="{ item }">
            <div v-if="item.IsActive">بله</div>
            <div v-else>خیر</div>
          </template>
          <!--      <template v-slot:[`item.TypeAdvertisements`]="{ item }">
                  <div class="p-2 d-flex justify-content-center">
                    {{ $propertyTypeItems[item.TypeAdvertisements - 1].name }}
                  </div>
                </template>-->
          <template v-slot:[`item.TypeRole`]="{ item }">
            <div class="p-2 d-flex justify-content-center">
              {{ $roles[item.TypeRole - 1].name }}
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
                class="edit-User"
                icon
                color="primary"
                :to="{path: 'setUser', query:{isNew:false , id:item.Id ?? item.ID}}">
              <i class="fas fa-edit ml-1 white--text"></i>
            </v-btn>
          </template>
        </v-data-table>
      </div>

    </div>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>


import NavigationDrawer from "@/Admin/components/navigationDrawer";

export default {
  name: "listUsers",
  components: {NavigationDrawer},
  metaInfo: {
    title: 'اتوماسیون-لیست کاربران'
  },
  data: () => ({
    deleteDialog: false,
    showLoaderDialog: false,
    src: 'logo.png',
    title: 'لیست کاربران',
    search: null,
    headers: [
      {text: 'عکس', value: 'FileUrl', sortable: false,},
      {text: 'نام', value: 'Name', sortable: false},
      {text: 'نام خانوادگی', value: 'Family', sortable: false},
      {text: 'فعال', value: 'IsActive', sortable: false},
      {text: 'نقش', value: 'TypeRole', sortable: false},
      {text: 'ویرایش/حذف', value: 'actions', sortable: false,},
    ],
    list: [],
    expanded: [],
    singleExpand: true,
    typeRole: null,
    isListLoaded: false,
  }),
  mounted() {
    if (this.$getUserData().token === '') {
      this.$router.replace({path: '/'})
    }
    this.typeRole = this.$route.query.role
  },
  methods: {
    searchUsers() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/ListUsers?TypeRole=" + this.typeRole, requestOptions)
          .then(response => response.text())
          .then(result => {
            this.list = JSON.parse(result)
            this.isListLoaded = true
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    /*getAllUsers() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/ListAllUsers", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.list = JSON.parse(result)
            console.log(this.list)
            this.isListLoaded = true
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },*/
    getImgUrl(pic) {
      return require('../../assets/img/' + pic)
    },
  }
}
</script>

<style scoped>

</style>
